import { computed } from 'vue';

export function useFormsChanged(formChangedStatuses) {
	const formsChanged = computed(() => {
		for (const value of Object.values(formChangedStatuses)) {
			if (value) {
				return true;
			}
		}
		return false;
	});

	return {
		formsChanged,
	}
}
